module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-input-wrapper"
  }, [_c('ul', {
    staticClass: "progress-boxs gutter-12 clearfix",
    attrs: {
      "id": "buttons-tab"
    }
  }, [_c('li', {
    staticClass: "progress-box gutter-12__li grid-3--xs",
    class: {
      active: _vm.step === 1
    }
  }, [_c('span', {
    staticClass: "progress-box__link org-line-btn block-btn"
  }, [_vm._v("\n          1. 기본정보"), (_vm.step === 1) ? _c('label', [_vm._v("(현재단계)")]) : _vm._e(), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('li', {
    staticClass: "progress-box gutter-12__li grid-3--xs",
    class: {
      active: _vm.step === 2
    }
  }, [_c('span', {
    staticClass: "progress-box__link org-line-btn block-btn"
  }, [_vm._v("\n          2. " + _vm._s(_vm.txt.info)), (_vm.step === 2) ? _c('label', [_vm._v("(현재단계)")]) : _vm._e(), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('li', {
    staticClass: "progress-box gutter-12__li grid-3--xs",
    class: {
      active: _vm.step === 3
    }
  }, [_c('span', {
    staticClass: "progress-box__link org-line-btn block-btn"
  }, [_vm._v("\n          3. 등록"), (_vm.step === 3) ? _c('label', [_vm._v("(현재단계)")]) : _vm._e()])])]), _vm._v(" "), (_vm.step === 1) ? _c('div', [_c('div', {
    staticClass: "basic-form"
  }, [_c('h4', {
    staticClass: "big-label"
  }, [_vm._v("신청자")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("신청자 이름")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.member.name))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("연락처")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.member.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("이메일")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.member.email))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    staticClass: "input__checkbox--with-etc",
    attrs: {
      "type": "checkbox",
      "id": "chkinfoId",
      "title": "신청자정보와 동일 선택"
    },
    on: {
      "click": _vm.chkinfo
    }
  }), _vm._v(" 신청자정보와 동일\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_ceoName"
    }
  }, [_vm._v("이름")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.booking.representative.name),
      expression: "booking.representative.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__text",
    attrs: {
      "id": "booking_ceoName",
      "type": "text",
      "placeholder": "대표자 이름을 입력해 주세요.",
      "maxlength": "30",
      "title": "대표자 이름을 입력해 주세요."
    },
    domProps: {
      "value": (_vm.booking.representative.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking.representative, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_contect"
    }
  }, [_vm._v("연락처")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.booking.representative.phone),
      expression: "booking.representative.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__text",
    attrs: {
      "id": "booking_contect",
      "type": "text",
      "placeholder": "대표자 연락처를 '-'를 빼고 숫자로만 입력해 주세요.",
      "maxlength": "30",
      "title": "대표자 연락처를 '-'를 빼고 숫자로만 입력해 주세요."
    },
    domProps: {
      "value": (_vm.booking.representative.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking.representative, "phone", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_email"
    }
  }, [_vm._v("이메일")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.booking.representative.email),
      expression: "booking.representative.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__text",
    attrs: {
      "id": "booking_email",
      "type": "email",
      "placeholder": "대표자 이메일을 입력해주세요. 예) email@naver.com",
      "maxlength": "50",
      "title": "대표자 이메일을 입력해주세요. 예) email@naver.com"
    },
    domProps: {
      "value": (_vm.booking.representative.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking.representative, "email", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-submit-gruop"
  }, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToStep2
    }
  }, [_vm._v("다음")])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('div', {
    staticClass: "basic-form"
  }, [_c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("기관")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.room.org))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("공간")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.room.name))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "date"
    }
  }, [_vm._v("일시")]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10"
  }, [_c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [(!_vm.communityPlus) ? _c('datepicker', {
    attrs: {
      "input-class": 'input__text',
      "language": "ko",
      "format": 'yyyy-MM-dd',
      "id": "date",
      "disabled": _vm.state.disabled
    },
    on: {
      "closed": _vm.setBookingDate
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.communityPlus) ? _c('datepicker', {
    attrs: {
      "input-class": 'input__text',
      "language": "ko",
      "format": 'yyyy-MM-dd',
      "id": "date",
      "disabled": _vm.statePlus.disabled
    },
    on: {
      "closed": _vm.setBookingDate
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.startTime),
      expression: "booking.startTime"
    }],
    staticClass: "input__select",
    attrs: {
      "title": "대관 시작시간 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "startTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.setBookingDate()
      }]
    }
  }, _vm._l((25), function(n) {
    return _c('option', {
      domProps: {
        "value": _vm.getTimeValue(n)
      }
    }, [_vm._v("\n                  " + _vm._s(Math.ceil(n / 2) + 8) + ":" + _vm._s(n % 2 === 1 ? '00' : '30') + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.endTime),
      expression: "booking.endTime"
    }],
    staticClass: "input__select",
    attrs: {
      "title": "대관 종료시간 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "endTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.setBookingDate()
      }]
    }
  }, _vm._l((25), function(n) {
    return _c('option', {
      domProps: {
        "value": _vm.getTimeValue(n)
      }
    }, [_vm._v("\n                  " + _vm._s(Math.ceil(n / 2) + 8) + ":" + _vm._s(n % 2 === 1 ? '00' : '30') + "\n                ")])
  }), 0)])]), _vm._v("\n          (사용료 결제 이후 승인 예정이며, 사용료 결제는 시설 사용 2일 전까지 완료되어야 합니다.)\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_roomCharge"
    }
  }, [_vm._v(_vm._s(_vm.costTitle))]), _vm._v(" "), _c('input', {
    staticClass: "input__text",
    attrs: {
      "id": "booking_roomCharge",
      "type": "number",
      "readonly": "",
      "title": "booking_roomCharge 입력"
    },
    domProps: {
      "value": _vm.exCost
    }
  })]), _vm._v(" "), (_vm.roomItems[_vm.selectedItem]) ? _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_optionStuff"
    }
  }, [_vm._v("옵션 물품 신청")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "gutter-10 clearfix"
  }, [_c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedItem),
      expression: "selectedItem"
    }],
    staticClass: "input__select",
    attrs: {
      "id": "booking_optionStuff",
      "title": "booking_optionStuff 선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.roomItems), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('input', {
    staticClass: "input__text input__text--readonly",
    attrs: {
      "readonly": "",
      "title": "옵션 물품 신청 가격"
    },
    domProps: {
      "value": _vm.roomItems[_vm.selectedItem].cost
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('button', {
    staticClass: "block-btn xs-btn btn--blue",
    attrs: {
      "id": "addBtn"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("추가")])])]), _vm._v(" "), _c('div', {
    staticClass: "added-list"
  }, [_c('h6', {
    staticClass: "added-list__title"
  }, [_vm._v("추가된 리스트")]), _vm._v(" "), _vm._l((_vm.optionItems), function(item, index) {
    return _c('div', {
      staticClass: "gutter-10 clearfix"
    }, [_c('div', {
      staticClass: "gutter-10__li grid-3"
    }, [_c('input', {
      staticClass: "input__text input__text--readonly",
      attrs: {
        "type": "text",
        "readonly": "",
        "title": "추가 옵션 물품 신청 물품"
      },
      domProps: {
        "value": item.name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "gutter-10__li grid-3"
    }, [_c('input', {
      staticClass: "input__text input__text--readonly",
      attrs: {
        "type": "text",
        "readonly": "",
        "title": "추가 옵션 물품 신청 가격"
      },
      domProps: {
        "value": item.cost
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "gutter-10__li grid-3"
    }, [_c('button', {
      staticClass: "block-btn xs-btn line-btn--red",
      on: {
        "click": function($event) {
          return _vm.delItem(index)
        }
      }
    }, [_vm._v("삭제")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "gutter-10 clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('input', {
    staticClass: "input__text input__text--total",
    attrs: {
      "type": "text",
      "id": "booking_sum",
      "readonly": "",
      "title": "물품비용 합계"
    },
    domProps: {
      "value": _vm.addtionalCost
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  })])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_roomChargeTotal"
    }
  }, [_vm._v("총 비용")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.booking.totalCost),
      expression: "booking.totalCost",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__text input__text--readonly",
    attrs: {
      "id": "booking_roomChargeTotal",
      "type": "text",
      "readonly": "readonly",
      "title": "booking_roomChargeTotal 입력"
    },
    domProps: {
      "value": _vm.ttlCost,
      "value": (_vm.booking.totalCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "totalCost", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "group"
    }
  }, [_vm._v("단체명")]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10 clearfix"
  }, [_c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkPlus),
      expression: "checkPlus"
    }],
    staticClass: "input__checkbox--with-etc",
    attrs: {
      "id": "booking_cmKind",
      "type": "checkbox",
      "disabled": _vm.room.status === 'COMMUNITY' || _vm.communities.length === 0,
      "title": "커뮤니티 대관 체크박스"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkPlus) ? _vm._i(_vm.checkPlus, null) > -1 : (_vm.checkPlus)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkPlus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkPlus = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkPlus = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkPlus = $$c
        }
      }, _vm.changeCheckPlus]
    }
  }), _vm._v(" 커뮤니티 대관\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.communitieList),
      expression: "communitieList"
    }],
    staticClass: "inline-input-etc__select",
    attrs: {
      "disabled": _vm.communities.length === 0,
      "title": "커뮤니티 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.communitieList = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectedCommunity]
    }
  }, _vm._l((_vm.communities), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.booking.groupName),
      expression: "booking.groupName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__text",
    attrs: {
      "type": "text",
      "placeholder": "단체명을 입력해 주세요. (30자 이하)",
      "maxlength": "30",
      "id": "group",
      "title": "단체명을 입력해 주세요. (30자 이하)"
    },
    domProps: {
      "value": (_vm.booking.groupName)
    },
    on: {
      "change": _vm.groupNameValidate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "groupName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_purpose"
    }
  }, [_vm._v(_vm._s(_vm.txt.purpose))]), _vm._v("\n                    \t커뮤니티 외 단체의 경우 단체 성격, 단체 운영목적, " + _vm._s(_vm.txt.purpose) + "을 상세하게 작성 해 주시기 바랍니다.\n          "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.booking.purpose),
      expression: "booking.purpose",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__textarea",
    attrs: {
      "id": "booking_purpose",
      "maxlength": "1000",
      "title": "booking_purpose 입력"
    },
    domProps: {
      "value": (_vm.booking.purpose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "purpose", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_personnel"
    }
  }, [_vm._v("사용인원")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.booking.personnel),
      expression: "booking.personnel",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__text input__text--sm",
    attrs: {
      "id": "booking_personnel",
      "type": "number",
      "min": "1",
      "maxlength": "8",
      "title": "사용인원 입력",
      "onkeydown": "javascript: if (this.value.length >= this.maxLength && (event.key >= 0 && event.key <= 9)) return false;\n                     return ((event.key >= 0 && event.key <= 9) || (event.keyCode >= 8 && event.keyCode <= 46) || (event.keyCode >= 91 && event.keyCode <= 93)\n                     || (event.keyCode >= 112 && event.keyCode <= 123) || (event.keyCode >= 144 && event.keyCode <= 145)\n                     || (event.ctrlKey && event.keyCode == 67) || (event.ctrlKey && event.keyCode == 86)) ? true : false"
    },
    domProps: {
      "value": (_vm.booking.personnel)
    },
    on: {
      "change": _vm.checkNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "personnel", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-submit-gruop"
  }, [_c('button', {
    staticClass: "form-submit__btn line-btn--red",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToStep1
    }
  }, [_vm._v("이전")]), _vm._v(" "), _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToStep3
    }
  }, [_vm._v("다음")])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', [_c('div', {
    staticClass: "basic-form"
  }, [_c('div', {
    staticClass: "inline-input-group clearfix",
    attrs: {
      "for": "booking_org"
    }
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "id": "booking_org"
    }
  }, [_vm._v("기관")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [_vm._v(_vm._s(_vm.room.org))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_place"
    }
  }, [_vm._v("공간")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text",
    attrs: {
      "id": "booking_place"
    }
  }, [_vm._v(_vm._s(_vm.room.name))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "booking_creatDate"
    }
  }, [_vm._v("일시")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text",
    attrs: {
      "id": "booking_creatDate"
    }
  }, [_vm._v(_vm._s(_vm.bookingDate))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("총 비용(예상)")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text"
  }, [(_vm.communityPlus) ? _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("\n              0원\n            ")]) : (_vm.isPlus && _vm.checkPlus) ? _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("\n              0원\n            ")]) : _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("\n              " + _vm._s((_vm.exCost + _vm.addtionalCost)) + "원\n            ")]), _vm._v("\n            ( " + _vm._s(_vm.txt.cost) + " " + _vm._s(_vm.exCost) + " + 옵션물품 " + _vm._s(_vm.addtionalCost) + "\n            "), (_vm.communityPlus) ? [_vm._v("\n              , 커뮤니티플러스 회원할인\n            ")] : (_vm.isPlus && _vm.checkPlus) ? [_vm._v("\n              , 커뮤니티플러스 회원할인\n            ")] : _vm._e(), _vm._v("\n            )\n          ")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("옵션물품")]), _vm._v(" "), _c('div', {
    staticClass: "added-list added-list--confirm"
  }, [_c('h6', {
    staticClass: "added-list__title",
    staticStyle: {
      "color": "#282828"
    }
  }, [_vm._v("추가된 리스트")]), _vm._v(" "), _vm._l((_vm.optionItems), function(item) {
    return _c('p', {
      staticClass: "progress__only-text"
    }, [_vm._v(_vm._s(item.name) + "\n              "), _c('span', {
      staticClass: "progress__only-text__price"
    }, [_vm._v(_vm._s(item.cost))])])
  })], 2)]), _vm._v(" "), (_vm.room.orgCode !== 'gch') ? _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label"
  }, [_vm._v("첨부파일")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "formBookingFile01",
      "id": "formBookingFile01",
      "method": "post",
      "enctype": "multipart/form-data",
      "action": "/api/file-uploads"
    }
  }, [_c('input', {
    ref: "imgUrl",
    staticClass: "inline-input__file",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "bookingFile01",
      "accept": "image/gif, image/jpeg, image/png",
      "title": "첨부파일 선택버튼"
    },
    on: {
      "change": function($event) {
        return _vm.imgUrlChange()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "guide-text",
    staticStyle: {
      "color": "#282828"
    }
  }, [_vm._v("세금계산서 발행의 경우 사업자등록증을 첨부해 주세요.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-input-group clearfix"
  }, [(_vm.room.orgCode === 'nwc') ? _c('div', [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("노원50플러스센터 시설대관운영지침")]), _vm._v(" "), _vm._m(5)]) : (_vm.room.orgCode === 'djc') ? _c('div', [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("동작50플러스센터 대관운영규정")]), _vm._v(" "), _vm._m(6)]) : (_vm.room.orgCode === 'dsc') ? _c('div', [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("서울시도심권50플러스센터 대관지침")]), _vm._v(" "), _vm._m(7)]) : (_vm.room.orgCode === 'sdm') ? _c('div', [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("서대문50플러스센터 시설대관운영지침")]), _vm._v(" "), _vm._m(8)]) : (_vm.room.orgCode === 'sbc') ? _c('div', [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("성북50플러스센터 대관규정")]), _vm._v(" "), _vm._m(9)]) : (_vm.room.orgCode === 'gch') ? _c('div', [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("금천50플러스센터 대관규정")]), _vm._v(" "), _vm._m(10)]) : _c('div', [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("공간이용규정 동의")]), _vm._v(" "), (_vm.isPortal) ? _c('div', {
    staticClass: "text-area-box"
  }, [_c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 배상책임")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 사용자의 준수사항")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 사용 취소 신청 및 환불")]), _vm._v(" "), _vm._m(13)]) : _c('div', {
    staticClass: "text-area-box"
  }, [_c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 배상책임")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 대관자의 준수사항")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 대관 취소 신청 및 환불")]), _vm._v(" "), _vm._m(16)])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('label', {
    staticClass: "checkbox-inline progress-label__agree-ckeck"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree2),
      expression: "agree2"
    }],
    staticClass: "input__checkbox",
    attrs: {
      "type": "checkbox",
      "title": "약관동의 체크박스"
    },
    domProps: {
      "checked": Array.isArray(_vm.agree2) ? _vm._i(_vm.agree2, null) > -1 : (_vm.agree2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree2 = $$c
        }
      }
    }
  }), _vm._v(" 동의\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-submit-gruop"
  }, [_c('button', {
    staticClass: "form-submit__btn line-btn--red",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.goToStep2
    }
  }, [_vm._v("이전")]), _vm._v(" "), _c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.checkReady
    }
  }, [_vm._v(_vm._s(_vm.txt.regButton))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-arrow-circle"
  }, [_c('img', {
    staticClass: "progress-box__img",
    attrs: {
      "src": "/images/icon-right-arrow-big.png",
      "alt": "오른쪽 화살표"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-arrow-circle"
  }, [_c('img', {
    staticClass: "progress-box__img",
    attrs: {
      "src": "/images/icon-right-arrow-big.png",
      "alt": "오른쪽 화살표"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "chkinfoId"
    }
  }, [_c('h4', {
    staticClass: "big-label"
  }, [_vm._v("대표자")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gutter-10 clearfix"
  }, [_c('div', {
    staticClass: "gutter-10__li grid-3 option-label"
  }, [_vm._v("물품")]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3 option-label"
  }, [_vm._v("가격")]), _vm._v(" "), _c('div', {
    staticClass: "gutter-10__li grid-3 option-label"
  }, [_vm._v("추가/삭제")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gutter-10__li grid-3"
  }, [_c('label', {
    staticClass: "option-total-label",
    attrs: {
      "for": "booking_sum"
    }
  }, [_vm._v("물품비용 합계")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-box"
  }, [_c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 대관시간")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 센터의 대관시간은 서울시50+센터 운영지침 및 센터의 운영일을 기준으로 하며, 평일에는 오전9시부터 오후9시까지, 토요일은 오전 9시부터 오후 5시까지로 한다. 단, 일요일과 법정공휴일은 휴관으로 별도 개방하지 않으며, 센터의 개방일정에 의해 유동적으로 대관할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("② 대관시간")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("대관시간")]), _vm._v(" "), _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("요일")]), _vm._v(" "), _c('th', {
    staticClass: "last",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("대관가능기간")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("평  일")]), _vm._v(" "), _c('td', [_vm._v("월~금요일")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("9:00 ~ 21:00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("주  말")]), _vm._v(" "), _c('td', [_vm._v("토요일")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("9:00 ~ 17:00")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 대관취소 및 변경")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 다음 각 호에 해당하는 때에는 대관을 취소 혹은 변경 할 수 있다.\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 시설사용 신청내용이 행사의 내용과 다를 때")]), _vm._v(" "), _c('li', [_vm._v("- 대관승인 조건을 위반 할 때")])])]), _vm._v(" "), _c('li', [_vm._v("② 센터장은 대관예정인 시설공간이 천재지변 및 기타 이에 준하는 사태로 사용 할 수 없게 된 때에는 대관을 취소하고 대관통지를 받은 자에게 자체 없이 그 사실을 통지하여야 한다.")]), _vm._v(" "), _c('li', [_vm._v("③ 대관신청인은 대관취소 시, 행사 예정일 3일 전까지는 홈페이지를 통해 취소요청을 하여야 한다.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 대관료")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 센터 시설의 시설운영등에 소요되는 비용을 충당하기 위해 제5조의 규정에 의하여 대관결정 승인을 받은 자는 별도로 정한 시설대관 이용료 기준에 따라 대관료를 납부하여야 하며 징수비용은 관련 자치구 조례를 기준으로 책정하되 조례변경시 변경할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("② 사용신청 취소 및 변경사항은 최소 사용일 3일 전까지 통지하여야 한다.")]), _vm._v(" "), _c('li', [_vm._v("③ 대관료 징수는 사용예정일 3일전까지는 납부하여야 한다. ")]), _vm._v(" "), _c('li', [_vm._v("④ 시설 대관료는 노원50플러스센터 목적사업에 사용한다.")]), _vm._v(" "), _c('li', [_vm._v("⑤ 시설대관 이용료 기준\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 수시대관의 경우 관련 자치구 조례를 근거로 하며 조례변경시 변경할 수 있다.")])])])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("시설대관 이용료 기준")]), _vm._v(" "), _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "auto"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col",
      "rowspan": "2",
      "colspan": "2"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col",
      "colspan": "3"
    }
  }, [_vm._v("3층")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("4층")]), _vm._v(" "), _c('th', {
    staticClass: "last",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("5층")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("배움탐색실")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("함께부엌")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("미래설계실")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("이음강당")]), _vm._v(" "), _c('th', {
    staticClass: "last",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("도시락카페")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("수용인원")]), _vm._v(" "), _c('td', [_vm._v("20명")]), _vm._v(" "), _c('td', [_vm._v("12명")]), _vm._v(" "), _c('td', [_vm._v("15명")]), _vm._v(" "), _c('td', [_vm._v("50명")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("스탠딩")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("비치물품")]), _vm._v(" "), _c('td', [_vm._v("빔프로젝트책상 · 의자냉난방")]), _vm._v(" "), _c('td', [_vm._v("조리도구 책상 · 의자냉난방")]), _vm._v(" "), _c('td', [_vm._v("빔프로젝트책상 · 의자냉난방")]), _vm._v(" "), _c('td', [_vm._v("빔프로젝트음향장비 · 마이크책상 · 의자 냉난방")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("대관료")]), _vm._v(" "), _c('td', [_vm._v("3시간이내")]), _vm._v(" "), _c('td', [_vm._v("20,000원")]), _vm._v(" "), _c('td', [_vm._v("50,000원")]), _vm._v(" "), _c('td', [_vm._v("20,000원")]), _vm._v(" "), _c('td', [_vm._v("50,000원")]), _vm._v(" "), _c('td', {
    staticClass: "last",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("없음")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3시간~5시간")]), _vm._v(" "), _c('td', [_vm._v("30,000원")]), _vm._v(" "), _c('td', [_vm._v("70,000원")]), _vm._v(" "), _c('td', [_vm._v("30,000원")]), _vm._v(" "), _c('td', [_vm._v("70,000원")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5시간 초과")]), _vm._v(" "), _c('td', [_vm._v("50,000원")]), _vm._v(" "), _c('td', [_vm._v("100,000원")]), _vm._v(" "), _c('td', [_vm._v("50,000원")]), _vm._v(" "), _c('td', [_vm._v("100,000원")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("기타")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("노트북 대여 불가 / 함께 부엌은 화기 사용 불가센터 교육프로그램에 따라 대관 일정이 변경될 수 있음")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("자율이용 가능5명 이상 단체사전신청")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("4. 사용요금 반환")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 시설의 안전관리 및 유지보수 등 시설의 책임으로 일정기간 교육과정 및 시설을 이용할 수 없게 된 경우 : 전체금액 반환")]), _vm._v(" "), _c('li', [_vm._v("② 교육과정 취소·변경 또는 천재지변 등 부득이한 사유로 이용이 불가능하게 된 경우")]), _vm._v(" "), _c('li', [_vm._v("③ 센터의 귀책사유 및 천재지변 등의 불가항력적인 사유발생 시 : 사용료의 전체")]), _vm._v(" "), _c('li', [_vm._v("④ 과오납 징수 : 전체금액 반환")]), _vm._v(" "), _c('li', [_vm._v("⑤ 사용개시일 전일까지는 전액 반환하며, 사용개시일 당일은 반환 불가")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("5. 대관신청제한 및 금지")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 센터는 다음 각 호에 해당하는 자에게는 대관신청을 제한하거나 신청을 받지 않을 수 있다.\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 공공질서 유지 및 미풍양속 등 공익을 해하거나 사회적 통념을 위반하는 내용")]), _vm._v(" "), _c('li', [_vm._v("- 센터시설 및 설비를 심각하게 훼손할 우려가 있거나 시설 및 설비의 관리 유지상 부적절한 행사를 목적으로 하는 경우")]), _vm._v(" "), _c('li', [_vm._v("- 센터의 사용조건을 위반하거나 기존에 허위 작성으로 대관신청을 취소한 사실이 있는 경우")]), _vm._v(" "), _c('li', [_vm._v("- 승인단체 이외의 단체 등에 사용을 양도한 경우")]), _vm._v(" "), _c('li', [_vm._v("- 사회적물의를 일으킬 수 있는 소지의내용이들어있는 행사를 목적으로 하는 경우")]), _vm._v(" "), _c('li', [_vm._v("- 영리를 목적으로 하는(유료입장, 물품판매 등) 경우")]), _vm._v(" "), _c('li', [_vm._v("- 특정 종교 포교활동 또는 정치적인 목적, 영리목적의 행사인 경우 ")]), _vm._v(" "), _c('li', [_vm._v("- 센터의 운영목적 또는 설립 취지 등에 위배되는 내용의 대관을 신청한 경우")])])]), _vm._v(" "), _c('li', [_vm._v("② 센터는 다음 각 호에 해당하는 때에는 대관을 취소하거나 사용을 중지할 수 있다.\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 대관승인 후 신청기재 사실이 허위로 밝혀졌을 대")]), _vm._v(" "), _c('li', [_vm._v("- 센터와의 협의 없이 판매등 임의의 행사를 진행 할 때")]), _vm._v(" "), _c('li', [_vm._v("- 대관자가 대관 사용권을 제3자에게 양도 또는 전대하는 경우")]), _vm._v(" "), _c('li', [_vm._v("- 지정한 기일내 대관료를 납부하지 않았을 경우")]), _vm._v(" "), _c('li', [_vm._v("- 센터내 흡연, 음주, 위험물 사용 등 그 외 이와 유사한 행위 또는 반입한 경우 ")]), _vm._v(" "), _c('li', [_vm._v("- 대관행사 종료후 사용시설물과 물품을 요구한대로 정리하지 않았을 경우")]), _vm._v(" "), _c('li', [_vm._v("- 센터내에서 다른 이용자 및 대관자에게 불편을 주는 행위를 했을 경우")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("6. 준수사항 및 개방조건")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 시설사용의 승인된 목적에 따라 다음 각 호의 의거를 준수하여야 한다.\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 냉난방시설, 위험물시설, 기타 주요시설은 센터 관리자의 승인없이 임의로 사용 및 설치ㆍ철거할 수 없으며, 사용시설 내에 행사에 불필요하다고 판단되는 물품 및 허가되지 않는 각종 음식물의 반입은 금지한다. ")]), _vm._v(" "), _c('li', [_vm._v("- 센터내외 시설 및 기물이 훼손되지 않도록 하여야 하고, 분실 및 훼손되었을 경우 그 손해는 대관자가 이를 변상하고, 사용한 시설설비는 행사 후 기존의 설치상태로 원상복귀 하여야 한다. ")]), _vm._v(" "), _c('li', [_vm._v("- 사용자에게 피해가 가지 않도록 하며 청결 및 공공질서를 유지하며, 시설사용 중 발생하는 쓰레기는 대관자가 수거하여 분리배출 처리하고 그에 따른 비용은 대관자가 부담하여야 한다. ")]), _vm._v(" "), _c('li', [_vm._v("- 시설 이용 시, 안전관리수칙을 반드시 준수하여야 하며 이를 준수하지 않은 결과로 야기된 안전사고에 대하여 대관자가 모든 책임을 진다.")]), _vm._v(" "), _c('li', [_vm._v("- 센터는 대관 중 행사와 관련하여 발생된 인적․물적사고에 대하여 손해배상을 포함한 민형사상 책임을 지지 않는다. ")]), _vm._v(" "), _c('li', [_vm._v("- 시설사용자는 사용기간 중 특별한 설비가 필요한 때에는 센터 관리자의 허락을 얻어야 하며, 대관자가 가져온 부대설비 및 각종 기자재와 장비 등 이와 유사한 모든 것에 문제가 있을 시 센터는 이로 인한 손해배상이나 손실보상의 책임을 지지 않는다. ")]), _vm._v(" "), _c('li', [_vm._v("- 대관자는 센터에서 제공한 컴퓨터 및 노트북 사용시 개인정보 및 단체기밀 등이 유출되지 않도록 해야하며, 센터는 정보 및 기밀 유출로 인한 손해배상이나 손실보상의 책임을 지지 않는다. ")]), _vm._v(" "), _c('li', [_vm._v("- 제 13조에 의거하여 대관시설의 사용을 제한 및 취소할 경우, 대관자에게 손해가 있을지라도 센터는 그 배상책임을 지지 않는다.")]), _vm._v(" "), _c('li', [_vm._v("- 시설 내에서는 흡연 및 음주행위를 할 수 없다.")]), _vm._v(" "), _c('li', [_vm._v("- 음향사용 및 고성방가등의 행위로 인근주민들로부터 민원이 발생하지 않도록 주의한다.")]), _vm._v(" "), _c('li', [_vm._v("- 시설 대관시간은 반드시 준수하여야 한다.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-box"
  }, [_c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 목적")]), _vm._v(" "), _c('p', [_vm._v("이 운영 규정은 동작50+센터(이하 ‘센터’라 한다)내 대관 지침에 관한 제반 사항 규정을 정함을 목적으로 한다.")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 대관 허가기준")]), _vm._v(" "), _c('p', [_vm._v("본 센터는 대관사용 신청이 접수된 순서에 따라 대관승인 심사절차를 진행하며, 본 센터 설립 목적의 적합성, 일정의 수용 가능성, 공익적인 교육 및 행사 등을 감안하여 승인 여부를 결정한다.")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 대관료의 반환")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("사용자가 이미 납부한 대관료는 다음 각 호에 해당하는 경우를 제외하고는 이를 반환하지 아니한다.")]), _vm._v(" "), _c('li', [_vm._v("① 재해 등 천재지변, 기타 불가항력인 사유로 대관사용이 불가능한 경우, 또는 본 센터의 귀책사유로 사용이 불가능한 경우에는 기 납부한 대관료 전액을 반환한다.")]), _vm._v(" "), _c('li', [_vm._v("② 센터는 다음에 따라 사용료를 환불한다.\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 사용개시일 당일 : 환불불가")]), _vm._v(" "), _c('li', [_vm._v("- 사용개시일 전일까지 : 전액환불")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("4. 대관 승인불허")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("센터는 다음 각 호의 1에 해당하는 경우에는 대관승인을 불허할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("① 운영 목적 또는 센터 설립 취지 등에 위배되는 내용의 대관을 신청하는 경우")]), _vm._v(" "), _c('li', [_vm._v("② 과도한 시설물의 설치로 본 센터의 시설 및 설비를 심각히 훼손할 우려가 있거나 또는 센터의 관리, 유지상 부적절한 행사를 목적으로 하는 경우")]), _vm._v(" "), _c('li', [_vm._v("③ 센터 운영에 있어 방호 및 안전에 문제가 있거나 소음, 소란, 선동 등으로 타 행사를 방해할 우려가 있는 경우")]), _vm._v(" "), _c('li', [_vm._v("④ 상품, 유료 서비스의 홍보와 판매를 주된 목적으로 하는 경우")]), _vm._v(" "), _c('li', [_vm._v("⑤ 종교적 · 정치적 · 상업적인 목적 또는 기타 불순한 목적으로 이용하는 경우")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("5. 대관 계약해지")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관승인 시 지정한 기일 내에 계약을 체결하지 않거나 대관료를 납부하지 않을 경우")]), _vm._v(" "), _c('li', [_vm._v("② 대관승인 후 대관신청의 기재사실이 허위로 밝혀졌거나, 사용 내용에 중대한 변경 사항이 있을 경우")]), _vm._v(" "), _c('li', [_vm._v("③ 대관 신청자가 대관승인 받은 사항을 타인에게 양도하거나 전대하였을 경우")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("6. 대관 사용의무")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 사용자는 대관 시설과 설비에 관하여 선량한 사용자로서의 주의 의무를 다해야 하며, 특히 화재 예방에 최선을 다해야 한다.")]), _vm._v(" "), _c('li', [_vm._v("② 사용자는 대관 사용 후, 모든 설비 및 설치품목에 대해 사용전과 같은 원위치로의 원상복구 의무를 갖는다.")]), _vm._v(" "), _c('li', [_vm._v("③ 시설 및 기자재 작동은 사용자가 직접 조작해야 한다.")]), _vm._v(" "), _c('li', [_vm._v("④ 사용자는 준비, 사용, 철수기간 중 발생하는 쓰레기를 직접 수거하고 반출하여야 한다.")]), _vm._v(" "), _c('li', [_vm._v("⑤ 사용자는 다음과 같은 행위를 하여서는 안 된다.\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 과도한 전기사용 및 음향 설비 사용으로 타 이용자의 시설물 사용을 방해하는 행위")]), _vm._v(" "), _c('li', [_vm._v("- 센터 강의실 내에서 음식물을 취사 또는 조리하거나 사전에 협의되지 않은 음식물을 반입하는 행위  ")])])]), _vm._v(" "), _c('li', [_vm._v("⑥ 사용자는 대관사용 후 담당자 또는 관계자 입회하에 시설물을 점검 받아야 한다.")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("7. 손해 배상책임")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 사용자가 대관 사용의무를 소홀히 하여 시설 및 설비에 대하여 손해를 발생시켰을 경우에는 지체 없이 그 손해를 배상해야 한다.")]), _vm._v(" "), _c('li', [_vm._v("② 대관기간 중(준비 및 철수기간 포함) 센터의 고의 또는 과실이 있는 경우를 제외하고는 어떠한 인적, 물적 손해에 대해서도 센터가 손해배상 책임을 지지 않는다.")])]), _vm._v(" "), _c('p', [_vm._v("이 지침의 미숙지 및 위반으로 인해 발생하는 모든 책임은 사용자가 부담하며, 이로 인하여 상대방에게 손해를 입힐 경우에는 사용자가 이를 배상해야 한다.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-box"
  }, [_c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제1조(목적)")]), _vm._v(" "), _c('p', [_vm._v("이 지침은 서울특별시 장년층 인생이모작 지원에 관한 조례에 근거하여 재단법인 서울특별시50플러스재단(이하 ‘재단’이라고 한다)이 서울특별시(이하 ‘시’라고 한다)로부터 위탁받아 운영하는 서울시도심권50플러스센터(이하 “센터”라 한다) 대관운영에 관한 제반사항 규정을 목적으로 한다.")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제2조(대관신청 및 제외 대상)")]), _vm._v(" "), _c('p', [_vm._v("본 센터 대관신청 승인 및 불가 대상은 다음과 같다.")]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("센터 대관신청 승인 및 불가 대상")]), _vm._v(" "), _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "17%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "26%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "auto"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("대관주체")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("승인")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("불가")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("대관료")]), _vm._v(" "), _c('th', {
    staticClass: "last",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("비고")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("서울시 및 운영법인")]), _vm._v(" "), _c('td', [_vm._v("중장년층을 대상으로 하는 공익적인 교육, 행사 등")]), _vm._v(" "), _c('td', [_vm._v("직원대상 교육, 회의 등 자체 행사")]), _vm._v(" "), _c('td', [_vm._v("무료")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("공문서 제출 시 적용가능")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("관련 공공기관 및 민간단체")]), _vm._v(" "), _c('td', [_vm._v("중장년층을 대상으로 하는 공익적인 교육, 행사 등")]), _vm._v(" "), _c('td', [_vm._v("상업적 또는 중장년층 대상이 아닌 교육, 행사 등")]), _vm._v(" "), _c('td', [_vm._v("감면(50%)")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("협약업무의 경우 예외 적용")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("센터 커뮤니티")]), _vm._v(" "), _c('td', [_vm._v("회원 간 소모임, 회의, 교육 등 각종 커뮤니티 활동")]), _vm._v(" "), _c('td', [_vm._v("회원 개인적인 용무나 상업적 활동")]), _vm._v(" "), _c('td', [_vm._v("무료")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("승인 등록된 커뮤니티")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제3조(대관가능 일자 및 시간)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관가능일자는 일요일, 공휴일을 제외한다.")]), _vm._v(" "), _c('li', [_vm._v("② 대관가능시간은 (평일) 09:00 ~ 20:30, (토요일) 09:00 ~ 16:00에 한해 가능하다.")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제4조(대관의 범위 및 대관료)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 센터 대관의 범위와 대관료는 아래와 같다.")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("센터 대관의 범위와 대관료")]), _vm._v(" "), _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "13%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "11%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "32%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "13%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "auto"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("층별")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("수용인원"), _c('br'), _vm._v("(명)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("규모(㎡)")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("기자재 보유현황")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("대관료(원)"), _c('br'), _vm._v("(2시간기준)")]), _vm._v(" "), _c('th', {
    staticClass: "last",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("비고")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("지하1층")]), _vm._v(" "), _c('td', [_vm._v("열린마당")]), _vm._v(" "), _c('td', [_vm._v("40")]), _vm._v(" "), _c('td', [_vm._v("99㎡")]), _vm._v(" "), _c('td', [_vm._v("빔, 스크린, 전자교탁, 음향, 책상(20개), 의자(40개), 칠판")]), _vm._v(" "), _c('td', [_vm._v("50,000원")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("2층")]), _vm._v(" "), _c('td', [_vm._v("배움터1")]), _vm._v(" "), _c('td', [_vm._v("30")]), _vm._v(" "), _c('td', [_vm._v("72.4㎡")]), _vm._v(" "), _c('td', [_vm._v("빔, 스크린, 전자교탁, 음향, 책상(15개), 의자(30개), 칠판")]), _vm._v(" "), _c('td', [_vm._v("40,000원")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("배움터2")]), _vm._v(" "), _c('td', [_vm._v("20")]), _vm._v(" "), _c('td', [_vm._v("48.7㎡")]), _vm._v(" "), _c('td', [_vm._v("빔, 스크린, 전자교탁, 음향, 책상(10개), 의자(20개), 칠판")]), _vm._v(" "), _c('td', [_vm._v("30,000원")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("배움터3")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("22.8㎡")]), _vm._v(" "), _c('td', [_vm._v("빔, 스크린 책상(3개), 의자(12개), 칠판")]), _vm._v(" "), _c('td', [_vm._v("20,000원")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("8층")]), _vm._v(" "), _c('td', [_vm._v("이룸터")]), _vm._v(" "), _c('td', [_vm._v("18")]), _vm._v(" "), _c('td', [_vm._v("40.8㎡")]), _vm._v(" "), _c('td', [_vm._v("빔, 스크린 책상(10개), 의자(20개), 칠판")]), _vm._v(" "), _c('td', [_vm._v("30,000원")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("작은목공실")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("40.4㎡")]), _vm._v(" "), _c('td', [_vm._v("책상(5개), 의자(10개), 전동실톱, 탁상드릴 등")]), _vm._v(" "), _c('td', [_vm._v("50,000원")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("*기계 사용료 포함")])])])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("※ 비 고")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1) 야간, 주말의 공연 및 행사에 대하여는 기준액의 100분의 20을 가산함.")]), _vm._v(" "), _c('li', [_vm._v("2) 초과사용료 가산\n\t\t\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 1시간미만 : 기본사용료의 100분의 50")]), _vm._v(" "), _c('li', [_vm._v("- 1시간 이상 2시간미만 : 기본사용료 전액")])])]), _vm._v(" "), _c('li', [_vm._v("3) 공간 내 부대시설(프로젝터, 음향시설) 사용가능 함.\n\t\t\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("- 단, 대관 희망 공간 내 부대시설(프로젝터, 음향시설) 이용 시, 사전에 문서로 사용승인을 받아야 하며, 기자재 고장   시 수선(수리비)료 각 단체가 부담 함.")])])]), _vm._v(" "), _c('li', [_vm._v("4) 기자재 보유현황에 명시된 기자재 외 추가 기자재는 대여가 불가능 함")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제5조(대관신청 절차)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관을 희망할 경우 본 센터 홈페이지(50plus.or.kr/dsc)를 통해 대관희망일 최소 2주전에 신청한다(대관신청은 본 센터 홈페이지를 통해 신청하는 것을 원칙으로 하며 유선 및 방문 신청은 불가하다). 단, 본 센터의 사업 추진 준비기간에는 대관승인을 유예할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("② 홈페이지 대관신청 기입사항에 누락되는 사항이 없도록 상세하게 기입한다.")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제6조(대관심의)")]), _vm._v(" "), _c('p', [_vm._v("대관심의 절차는 아래와 같다.")]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("대관심의 절차")]), _vm._v(" "), _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "28%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "28%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "8%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "28%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("대관신청")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("⇨")]), _vm._v(" "), _c('td', [_vm._v("대관심의")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("⇨")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("대관가능여부 통보")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("센터 홈페이지 대관신청(각 항목 기입사항 누락여부 확인 등)")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t신청기관 등 적격여부"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t대관목적 적격여부"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t대관일정 가능여부"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t센터운영 목적 부합여부"), _c('br')]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("대관가능여부 통보")])])])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제7조(대관승인)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관승인은 본 센터 홈페이지 신청내역 확인 후 담당부서에서 결정한다.")]), _vm._v(" "), _c('li', [_vm._v("② 담당부서에서는 대관신청 접수 후 3일 이내에 심의하여 승인가부를 결정한다.")]), _vm._v(" "), _c('li', [_vm._v("③ 대관승인 시 대관료는 대관일 5일전까지 센터 계좌(우리은행 1005-402-909417 / 예금주 : 서울시도심권50플러스센터)로 납부한다(기한 내 미납 시 대관승인이 취소된다)")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제8조(대관승인 제한)")]), _vm._v(" "), _c('p', [_vm._v("다음 각 호에 해당하는 사유가 있는 경우에는 대관을 승인하지 않는다.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 특정종교의 포교 또는 정치적 · 상업적인 목적의 경우")]), _vm._v(" "), _c('li', [_vm._v("② 본 센터의 명예를 해할 우려가 있을 경우")]), _vm._v(" "), _c('li', [_vm._v("③ 신청자격이 정지중인 자가 신청하였을 경우")]), _vm._v(" "), _c('li', [_vm._v("④ 센터의 관리, 운영에 지장이 있을 경우")]), _vm._v(" "), _c('li', [_vm._v("⑤ 센터와 사용계획이 중복될 경우")]), _vm._v(" "), _c('li', [_vm._v("⑥ 기타 부적당하다고 인정할 경우")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제9조(대관취소 및 해지)")]), _vm._v(" "), _c('p', [_vm._v("다음 각 호에 해당하는 경우 대관허가 취소 및 해지를 할 수 있다.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관허가 후 대관신청서의 기재사실이 허위로 밝혀졌거나, 사용 내용 중에 중대한 변경사항이 있을 때")]), _vm._v(" "), _c('li', [_vm._v("② 대관허가 시 지정한 기일 내에 대관료를 납부하지 않을 때")]), _vm._v(" "), _c('li', [_vm._v("③ 대관자가 대관허가 받은 사항을 타인에게 양도하거나 전대하였을 경우")]), _vm._v(" "), _c('li', [_vm._v("④ 공간별 사용수칙과 대관계약에 위배되는 행위를 하였을 경우")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제10조(대관계약 취소)")]), _vm._v(" "), _c('p', [_vm._v("대관자는 대관취소를 원할 경우 사용일의 일부 또는 전체를 취소할 수 있으며, 다음 각 호에 따라 대관료의 전부 또는 일부를 반환한다.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1. 100% 반환 : 천재지변, 기타 불가항력에 의해 대관취소, 사용일로부터 15일 이전에 대관을 취소하는 경우")]), _vm._v(" "), _c('li', [_vm._v("2. 80% 반환 : 사용일 14일 이전부터 7일 이전까지의 기간 동안 대관을 취소하는 경우")]), _vm._v(" "), _c('li', [_vm._v("3. 60% 반환 : 사용일 6일 이전부터 1일 이전까지의 기간 동안 대관을 취소하는 경우")]), _vm._v(" "), _c('li', [_vm._v("4. 50% 반환 : 사용기간 중 남은 기간에 대하여 대관취소 신청을 하는 경우")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제11조(사용내용 변경)")]), _vm._v(" "), _c('p', [_vm._v("대관자는 계약내용에 변경이 있을 경우 계약된 사용일로부터 15일 이전에 대관변경신청서를 제출하여 사전에 허가를 받아야 한다. 신청 내용에 따라 대관허가를 취소 또는 제한할 수 있다.")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제12조(시설사용원칙)")]), _vm._v(" "), _c('p', [_vm._v("대관자는 대관취소를 원할 경우 사용일의 일부 또는 전체를 취소할 수 있으며, 다음 각 호에 따라 대관료의 전부 또는 일부를 반환한다.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관자는 현수막, 홍보 안내물 및 가설물의 설치 또는 특수한 장비의 반입이 있는 경우 사전 허가를 받아야 한다. 허가받지 않은 설치물과 장비는 임의로 철거할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("② 대관자는 사용 종료 후 설치물을 철거하여야 하며, 설치 및 철수로 인해 기존 시설물, 설비에 손상을 가져온 경우는 변상하여야 한다.")]), _vm._v(" "), _c('li', [_vm._v("③ 대관자는 사전허가 없이 센터 내에 상업적 목적의 어떠한 설치물도 설치할 수 없다.")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제13조(관리의무 및 손해배상)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관자는 대관 시설과 설비에 관하여 선량한 사용자로서의 주의 의무를 다해야 하며, 특히 화재 예방에 최선을 다해야 한다.\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("1. 대관 시설과 설비에 대한 원상복구의 의무")]), _vm._v(" "), _c('li', [_vm._v("2. 화기 사용 금지의 의무")]), _vm._v(" "), _c('li', [_vm._v("3. 운영 시간 및 준비와 철수를 포함한 대관 이용시간 엄수의 의무")])])]), _vm._v(" "), _c('li', [_vm._v("② 대관자는 다음과 같은 행위를 하여서는 안 된다.\n\t\t\t\t\t\t"), _c('ul', [_c('li', [_vm._v("1. 과도한 전기 및 음향 사용으로 타 이용자의 사용을 방해하는 행위")]), _vm._v(" "), _c('li', [_vm._v("2. 음식물을 취사 또는 조리하거나 사전에 협의되지 않은 다량의 음식물을 반입하는 행위")]), _vm._v(" "), _c('li', [_vm._v("3. 협의하지 않은 물품 반입 및 타이용자의 사용을 방해하는 행위")])])]), _vm._v(" "), _c('li', [_vm._v("③ 대관자가 제1항의 관리의무를 소홀히 하여 시설 및 설비에 대하여 손해를 발생시켰을 경우에는 지체 없이 그 손해를 배상해야 한다.")]), _vm._v(" "), _c('li', [_vm._v("④ 대관자는 공간이용 수칙을 준수해야 하며 준수하지 않은 결과로 발생된 안전사고에 대한 민․형사상 책임을 진다.")]), _vm._v(" "), _c('li', [_vm._v("⑤ 대관자는 준비, 사용, 철수기간 중 발생하는 쓰레기를 직접 수거하고 반출하여야 한다.")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제14조(입장제한)")]), _vm._v(" "), _c('p', [_vm._v("본 센터는 다음 각 호에 해당하는 자에 대해서는 입장을 거절하거나 퇴장을 명할 수 있다.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 타인이 혐오할 만한 결함이 있거나 전염병 질환이 있는 자")]), _vm._v(" "), _c('li', [_vm._v("② 술에 취한 자")]), _vm._v(" "), _c('li', [_vm._v("③ 타인에게 위험을 주거나 방해가 될 물품을 휴대한 자")]), _vm._v(" "), _c('li', [_vm._v("④ 기타 본 센터 운영에 있어 지장이 있다고 인정되는 자")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제15조(이 규정에 정하지 않은 사항)")]), _vm._v(" "), _c('p', [_vm._v("이 규정에 정하지 않은 사항과 규정의 해석에 관하여는 서울특별시 인생이모작 지원에 관한 조례 및 동 시행규칙, 관계 법령 또는 선량한 풍속 기타 사회질서 등 관례에 따른다.")]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제16조(규정 미숙지 및 규정 위반 시의 책임)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 이 규정의 미숙지 및 규정 위반으로 인해 발생하는 모든 책임은 대관자가 부담하며, 이로 인하여 상대방에게 손해를 입힐 경우에는 대관자가 이를 배상한다.")]), _vm._v(" "), _c('li', [_vm._v("② 규정 위반에 대한 시정 요청 불이행시 즉시 대관행사 종료 및 강제 퇴장에 응한다.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-box"
  }, [_c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("1. 대관시간")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 월~금 10:00 ~ 20:00")]), _vm._v(" "), _c('li', [_vm._v("• 토요일 11:00 ~ 13:00")]), _vm._v(" "), _c('li', [_vm._v("• 일요일 및 공휴일은 센터 휴관")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("2. 대관 신청 및 대관료 납부")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 사용자가 온라인 신청 후 일정 검토, 대관료 납부 후 사용승인")]), _vm._v(" "), _c('li', [_vm._v("② 대관 2일 전까지 신청 가능")]), _vm._v(" "), _c('li', [_vm._v("③ 대관시스템을 이용한 카드결제와 무통장 입금 중 택 1")]), _vm._v(" "), _c('li', [_vm._v("※ 미입금 시 대관이 취소될 수 있습니다.")]), _vm._v(" "), _c('li', [_vm._v("④ 대관은 접수된 순서에 따라 승인심사 절차를 진행하며, 센터의 설립목적의 적합성, 센터 일정에 따라 최종 승인을 결정합니다.")]), _vm._v(" "), _c('li', [_vm._v("※ 대관 신청을 하셨어도 대관 목적에 따라 반려될 수 있습니다.")]), _vm._v(" "), _c('li', [_vm._v("⑤ 준비, 정리시간까지 포함해서 신청해주시기 바랍니다.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("3. 공간별 이용금액")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 야간, 휴일 대관의 경우, 냉난방기 사용할 경우 대관료의 30%가 가산되어 부과됩니다.")]), _vm._v(" "), _c('li', [_vm._v("② 이용시간은 최소 2시간 기본이며, 추가 1시간당 이용료가 가산되어 부과됩니다.")]), _vm._v(" "), _c('li', [_vm._v("③ 공간별 이용금액은 홈페이지 참조")])]), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("4. 대관 취소 및 환불절차")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관을 취소할 경우, 취소신청서를 제출해야 하며, 환불은 사용개시일 전(23:59)까지 100%, 당일 취소시 환불되지 않습니다.")]), _vm._v(" "), _c('li', [_vm._v("② 환불시 규정된 카드수수료 혹은 이체수수료가 발생할 수 있으며 공제 후 지급됩니다.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("5. 대관 주의사항")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 대관하신 공간을 이용하기 전 사무실을 방문해주세요.")]), _vm._v(" "), _c('li', [_vm._v("② 정치적, 종교적, 영리적 목적 사용은 대관이 불가합니다.")]), _vm._v(" "), _c('li', [_vm._v("③ 우리 센터의 교육일정이 확정되지 않은 기간의 경우, 사전 협의되지 않은 장기 대관은 승인이 취소될 수 있습니다.")]), _vm._v(" "), _c('li', [_vm._v("④ 참가자 통제가 불가능하거나 심한 소음, 진동 등으로 인해 센터 운영에 방해를 줄 수 있는 경우, 대관 주의사항을 준수하지 않은 경력이 있는 단체 또는 개인의 경우 대관이 제한될 수 있습니다.")]), _vm._v(" "), _c('li', [_vm._v("⑤ 센터 내에서 협의되지 않은 음식물 섭취는 불가하오니 양해바랍니다.")]), _vm._v(" "), _c('li', [_vm._v("⑥ 별도 주차공간이 없으니 인근 공영주차장을 이용해 주세요.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("6. 대관 기본수칙(약정)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 사용 중 시설물의 손상과 화재, 도난 등 사고에 의한 피해에 대해 신청자는 책임지고 원상복구 또는 배상을 해야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("② 허가없이 공간의 비품을 이동, 변경할 수 없으며, 사용 후 대관 담당자의 확인을 받은 후 사용을 종료해야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("③ 사전 협의없이 10분 이상 대관시간이 초과되는 경우, 이용료 기준에 따라 대관료가 추가로 부과 될 수 있습니다.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("7. 문의")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("• 운영지원팀 : 02)394-5060 (직통: 070-5220-3872)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-box"
  }, [_c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제1조(목적)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("이 규정은 성북50플러스센터(이하 “센터”라 한다) 운영규정 제4조 및 제30조에 규정하는 바에 따라 ")]), _vm._v(" "), _c('li', [_vm._v("센터의 시설 및 부대품을 대관 ‧ 대여하여 지역 내 행사에 사용할 수 있게 함으로써 센터의 효율적인 운영과 ")]), _vm._v(" "), _c('li', [_vm._v("이용자 및 지역 주민의 복지증진에 이바지하는 것을 목적으로 한다.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제2조(용어의 정리)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("대관 ‧ 대여에 대해 사용하는 용어의 정의는 다음과 같다.")]), _vm._v(" "), _c('li', [_vm._v("1. 대관: 공연, 연습, 전시, 행사, 회의 등을 위하여 시설, 부대품(설비 및 부대시설)을")]), _vm._v(" "), _c('li', [_vm._v("    센터가 정한 소정의 절차를 거쳐 임대 사용하는 것")]), _vm._v(" "), _c('li', [_vm._v("2. 사용자: 센터의 대관 승인을 받아 센터와 대관 계약을 체결한 사람이나 단체")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제3조(적용범위)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("대관은 신청 시기 및 목적에 따라 다음 각 호로 구분한다.")]), _vm._v(" "), _c('li', [_vm._v("1. 정기대관은 센터의 운영상황에 따라 차기년도 이후 시기의 대관도 신청할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("2. 수시대관은 프로그램이 운영되지 않을 경우 잔여 시간에 대해 수시로 이루어지는 대관을 말한다.")]), _vm._v(" "), _c('li', [_vm._v("3. 대관은 사용 목적에 따라 일반대관, 강좌대관, 커뮤니티대관, 기타대관 등으로 구분된다.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제4조(대관의 범위)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("센터가 대관할 수 있는 시설의 범위는 다음 각 호와 같다.")]), _vm._v(" "), _c('li', [_vm._v("1. 3층: 두근두근 오피스(인큐베이팅룸), 보글보글 키친(요리교실), 북적북적 카페(북카페)")]), _vm._v(" "), _c('li', [_vm._v("2. 4층: 강의실1, 강의실2, 강의실3")]), _vm._v(" "), _c('li', [_vm._v("3. 부대품: 빔프로젝터, 냉 ‧ 난방, 마이크(핀마이크, 무선마이크, 유선마이크) 등")]), _vm._v(" "), _c('li', [_vm._v("     기본시설 이외의 공간과 기본시설에 부속된 설비 및 장비. 단, 노트북 대여 불가")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제5조(대관의 신청)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("센터의 기본시설 및 부대시설을 대관 ․ 대여하고자 하는 자(이하 “사용자”라 한다)는 대관신청서를")]), _vm._v(" "), _c('li', [_vm._v("작성하여 7일 전까지 센터에 제출 및 홈페이지를 통해 신청하여야 한다.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제6조(대관의 승인)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 센터는 대관 사용 신청이 접수된 순서에 따라 이를 심사, 대관승인 가부 결과를 통지하여야한다.")]), _vm._v(" "), _c('li', [_vm._v("② 대관의 승인 기준은 센터가 대관 시설 운영실태 및 차기년도 운영방침 등을 고려하여 객관적으로 정한다.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제7조(대관의 제한)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("센터는 다음 각 호에 해당하는 경우에 대관신청을 제한한다.")]), _vm._v(" "), _c('li', [_vm._v("1. 센터의 운영 목적 또는 설립 취지 등에 위배되는 내용으로 신청하는 경우")]), _vm._v(" "), _c('li', [_vm._v("2. 센터의 시설 및 설비를 훼손할 우려가 있거나 센터의 관리유지상 부적절한 행사를 목적으로 하는 경우")]), _vm._v(" "), _c('li', [_vm._v("3. 신청자격이 정지 중인 자가 신청한 경우")]), _vm._v(" "), _c('li', [_vm._v("4. 특정(종교, 정치, 사적 영리, 노점 등) 목적의 행사인 경우")]), _vm._v(" "), _c('li', [_vm._v("5. 지정 기일 내에 대관신청서를 제출하지 않았거나 사용료를 납부하지 않았을 경우")]), _vm._v(" "), _c('li', [_vm._v("6. 대관 사용권을 무단으로 타인에게 양도 또는 전대하였을 경우")]), _vm._v(" "), _c('li', [_vm._v("7. 대관 계약 후 대관 일정을 무단으로 변경하였을 경우")]), _vm._v(" "), _c('li', [_vm._v("8. 본 대관 규정을 준수하지 않았을 경우")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제8조(사용료 등)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("사용료는 운영비, 감가상각비 등을 고려하여 센터 내에서 정하며 사용료는 아래와 같다.")])]), _vm._v(" "), _c('table', [_c('caption', [_vm._v("공간 이용금액")]), _vm._v(" "), _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "col",
      "colspan": "2",
      "rowspan": "2"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("3층")]), _vm._v(" "), _c('th', {
    staticClass: "last",
    attrs: {
      "scope": "col",
      "colspan": "3"
    }
  }, [_vm._v("4층")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("보글보글 키친")]), _vm._v(" "), _c('td', [_vm._v("강의실 1")]), _vm._v(" "), _c('td', [_vm._v("강의실 2")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("강의실 3")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("면적")]), _vm._v(" "), _c('td', [_vm._v("40.16㎡")]), _vm._v(" "), _c('td', [_vm._v("40.16㎡ 66.18㎡")]), _vm._v(" "), _c('td', [_vm._v("65.64㎡")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("51.84㎡")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("수용인원")]), _vm._v(" "), _c('td', [_vm._v("12명")]), _vm._v(" "), _c('td', [_vm._v("30명")]), _vm._v(" "), _c('td', [_vm._v("30명")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("20명")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("부대설비")]), _vm._v(" "), _c('td', [_vm._v("인덕션"), _c('br'), _vm._v("조리도구"), _c('br'), _vm._v("냉 ‧ 난방")]), _vm._v(" "), _c('td', [_vm._v("빔프로젝트"), _c('br'), _vm._v("책상 ‧ 의자"), _c('br'), _vm._v("음향장비 ‧ 마이크"), _c('br'), _vm._v("냉 ‧ 난방")]), _vm._v(" "), _c('td', [_vm._v("빔프로젝트"), _c('br'), _vm._v("책상 ‧ 의자"), _c('br'), _vm._v("음향장비 ‧ 마이크"), _c('br'), _vm._v("냉 ‧ 난방")]), _vm._v(" "), _c('td', {
    staticClass: "last"
  }, [_vm._v("빔프로젝트"), _c('br'), _vm._v("책상 ‧ 의자"), _c('br'), _vm._v("음향장비 ‧ 마이크"), _c('br'), _vm._v("냉 ‧ 난방")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("대관료")]), _vm._v(" "), _c('td', [_vm._v("3시간 이내")]), _vm._v(" "), _c('td', [_vm._v("50,000")]), _vm._v(" "), _c('td', [_vm._v("30,000")]), _vm._v(" "), _c('td', [_vm._v("30,000")]), _vm._v(" "), _c('td', [_vm._v("30,000")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3시간 ~ 5시간")]), _vm._v(" "), _c('td', [_vm._v("70,000")]), _vm._v(" "), _c('td', [_vm._v("50,000")]), _vm._v(" "), _c('td', [_vm._v("50,000")]), _vm._v(" "), _c('td', [_vm._v("50,000")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5시간 초과")]), _vm._v(" "), _c('td', [_vm._v("100,000")]), _vm._v(" "), _c('td', [_vm._v("80,000")]), _vm._v(" "), _c('td', [_vm._v("80,000")]), _vm._v(" "), _c('td', [_vm._v("80,000")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("※ 두근두근오피스의 대관 및 북적북적카페의 대관은 계약서에 근거하여 운영")]), _vm._v(" "), _c('li', [_vm._v("※ 5시간 초과 사용의 경우 센터 운영 시간 내에서만 가능")]), _vm._v(" "), _c('li', [_vm._v("※ 마이크의 경우 보유 수량의 미사용 시 대여 가능(보유수량: 대관 신청서 참조)")]), _vm._v(" "), _c('li', [_vm._v("※ 노트북 및 레이저포인터 대여 불가, 지참 필요")]), _vm._v(" "), _c('li', [_vm._v("※ 센터 교육 프로그램에 따라 대관 일정이 변경될 수 있음")]), _vm._v(" "), _c('li', [_vm._v("※ 대관 시간은 평일(월~금) 10:00~20:00, 주말(토) 10:00~17:00이며, 일요일 및 법정공휴일은 휴무")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제9조(사용료의 특례 및 감면)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("센터는 제한 없이 사용자에게 동일한 사용료를 징수한다.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제10조(사용료의 반환)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("사용료를 납부한 사람은 다음 각 호에 해당하는 경우에 센터는 사용료를 반환할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("1. 센터의 특별한 사정에 의하여 사용이 취소되거나 정지된 경우")]), _vm._v(" "), _c('li', [_vm._v("2. 천재지변 또는 그밖에 불가항력적인 사유로 인하여 시설 사용이 불가능한 경우")]), _vm._v(" "), _c('li', [_vm._v("3. 사용허가 후 사용예정일 3일 전에 취소할 경우 전날까지 취소 시 100% 환불, 당일 취소 시 환불 불가")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제11조(내용의 변경)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 사용자는 대관 사용권을 타인에게 양도 또는 전대하지 못한다.")]), _vm._v(" "), _c('li', [_vm._v("② 사용자는 대관 계약 후 임의로 내용 자체를 변경하여 진행할 수 없다. 단, 내용의 변경이 불가피할 경우 센터의 사전 승인을 받아야 한다.")]), _vm._v(" "), _c('li', [_vm._v("③ 사용자는 대관 계약 후 대관 일정을 변경할 수 없다. 다만, 상당한 사유가 있을 경우 센터의 승인을 받아야 한다.")]), _vm._v(" "), _c('li', [_vm._v("④ 사용자는 시설 및 설비에 변경을 가하거나 특별한 설비를 반입 ‧ 설치할 경우 센터의 사전 승인을 받아야 한다.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제12조(입장제한)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("센터는 다음 각 호에 해당하는 경우에는 사용자에게 참여자(대관실에 입장하고자 하는 사람)의 입장을 ")]), _vm._v(" "), _c('li', [_vm._v("거절하게 하거나 퇴장을 명하게 할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("1. 타인에게 유해한 행위를 하는 사람 또는 전염성 질환이 있는 사람")]), _vm._v(" "), _c('li', [_vm._v("2. 위험성이 있거나 타인에게 방해가 될 우려가 있는 물품을 휴대한 사람")]), _vm._v(" "), _c('li', [_vm._v("3. 기타 센터가 안전과 질서유지를 위하여 시설의 사용을 제한할 필요가 있다고 인정되는 자")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제13조(사용자의 의무 및 배상책임)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 사용자는 대관기간 중 센터의 시설 및 설비에 관하여 선량한 사용자로서의 주의 의무를 다하고, 센터가 정하는 안전관리 수칙을 준수해야 한다.")]), _vm._v(" "), _c('li', [_vm._v("② 사용자가 전항의 관리의무를 소홀히 하여 시설 및 설비에 대하여 훼손하거나 멸실하였을 때에는 그 손해를 배상하거나 원상으로 회복하여야 한다.")]), _vm._v(" "), _c('li', [_vm._v("③ 센터는 대관기간 중 대관행사와 관련하여 발생한 어떠한 인적, 물적 손해에 대하여서도 손해배상 책임을 지지 않는다. 다만 센터에게 고의 또는 중과실이 있는 경우에는 직접적인 손해의 범위 내에서 책임을 부담한다.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제14조(시용자의 안전관리)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 사용자가 행사, 작품전시 등을 위하여 설치하는 외부장치나 시설물은 화재예방, 소방시설 설치‧유지 및 안전관리에 관한 법률(약칭: 소방시설법)을 기준으로 하여 해당 법률에 저촉되지 않는 것으로 허가한다.")]), _vm._v(" "), _c('li', [_vm._v("② 센터는 공연이나 행사 시 화재발생 우려가 있는 폭죽, 총기 등 화약류 사용을 제한 할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("③ 제1항 및 제2항의 규정을 위반한 자에 대하여 센터는 시설사용 제한을 명령할 수 있으며 이로 인한 손해배상이나 손실보상의 책임을 지지 아니하며 사용자는 이의를 제기할 수 없다.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("제15조(사용자의 설비)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("① 사용자가 사용기간 중 특별한 장치와 설비(이하 “시설물”이라 한다)를 하고자 할 때는 미리 센터의 승인을 받아 사용자 부담으로 시설물을 설치하도록 할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("② 제1항의 규정에 의하여 시설물을 설치하였을 때에는 사용기간 만료와 동시에 이를 철거하고 원상복구 하여야 한다.")]), _vm._v(" "), _c('li', [_vm._v("③ 사용자가 제2항의 규정에 의한 의무를 이행하지 아니할 때에는 이를 센터에서 직접 원상복구하고 그 비용을 사용자로부터 징수한다. 만약 센터가 철거할 시 파손에 대한 책임을 지지 않는다.")])]), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-area-box"
  }, [_c('p', {
    staticClass: "area-box__middle-section"
  }, [_vm._v("대관 규정")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._v("1. 신청대상\n\t              "), _c('li', [_vm._v("  1) 지역 단체 및 개인")]), _vm._v(" "), _c('li', [_vm._v("  2) 금천구민 및 50+세대 이용자 우선")]), _vm._v(" "), _c('li', [_vm._v("  3) 1회성 사업에 대해서만 대관 가능")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._v("2. 신청방법\n\t              "), _c('li', [_vm._v("  1) 센터 홈페이지(https://50plus.or.kr/gch)를 통해 신청 가능하며, 전화 및 방문 접수는 불가하다.")]), _vm._v(" "), _c('li', [_vm._v("  2) 신청 접수는 대관 희망일 기준 2주 전까지 가능하다.")]), _vm._v(" "), _c('li', [_vm._v("  3) 센터 설립 목적의 적합성 및 센터 프로그램 일정을 고려하여 대관 승인 여부를 결정한다.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._v("3. 대관 장소\n\t              "), _c('li', [_vm._v("  1) 금천50플러스센터 내 강의실, 동아리실에 한한다.")]), _vm._v(" "), _c('li', [_vm._v("  2) 대관 장소 이용 시 정규 수업을 우선으로 한 후 대관 장소를 지정한다.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._v("4. 대관료\n          \t\t"), _c('table', [_c('caption', [_vm._v("공간 대관 사용료 안내")]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("구분")]), _vm._v(" "), _c('th', [_vm._v("기준시간")]), _vm._v(" "), _c('th', [_vm._v("금액")]), _vm._v(" "), _c('th', [_vm._v("비고")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("강의실")]), _vm._v(" "), _c('td', [_vm._v("6층 늘솜부엌(요리교실) 12인")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("2시간")]), _vm._v(" "), _c('td', [_vm._v("30,000원")]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("◦ 초과 시간 당"), _c('br'), _vm._v("50% 가산")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6층 배움터1(강의실) 24인")]), _vm._v(" "), _c('td', [_vm._v("15,000원")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7층 배움터3(강의실) 16인")]), _vm._v(" "), _c('td', [_vm._v("15,000원")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("동아리실")]), _vm._v(" "), _c('td', [_vm._v("6층 배움터2(동아리실) 8인")]), _vm._v(" "), _c('td', [_vm._v("10,000원")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._v("5. 환불 및 면제\n\t              "), _c('li', [_vm._v("  1) 접수는 홈페이지 내 온라인 접수를 통해서만 가능하며, 방문 및 유선으로는 불가능하다.")]), _vm._v(" "), _c('li', [_vm._v("  2) 신청방법 : (1) 마이페이지 → (2) 대관 내역 확인 및 대관 취소 → (3) 취소 사유 입력 → (4) 은행·계좌번호 작성 → (5) 신청자 명과 예금주 동일 여부 확인 → (6) 카드 결제 경우에도 계좌번호 작성")]), _vm._v(" "), _c('li', [_vm._v("  3) 환불기준")]), _vm._v(" "), _c('li', [_vm._v("    (1) 전액 환불 : 대관일 기준 3일 전 취소")]), _vm._v(" "), _c('li', [_vm._v("    (2) 대관 비용의 1/2 : 대관일 기준 1~2일 전 취소")]), _vm._v(" "), _c('li', [_vm._v("    (3) 반환하지 아니함. 대관 당일 취소")]), _vm._v(" "), _c('li', [_vm._v("  4) 면제 : 공공기관 및 유관기관 대관요청 공문 접수(자체 심사 후 면제 여부 결정)")]), _vm._v(" "), _c('li', [_vm._v("  5) 환불 금액은 원단위 절상하여 지급한다.")]), _vm._v(" "), _c('li', [_vm._v("  6) 취소로 인한 반환금이 발생할 경우 반환 사유 발생일로부터 동조 3항의 기준에 따라 운영일 기준 7일 이내 지급한다.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._v("6. 환불 및 면제\n\t              "), _c('li', [_vm._v("  1) 제한사항")]), _vm._v(" "), _c('li', [_vm._v("    (1) 질서유지, 시설관리 상 문제가 있다고 판단될 경우는 대관하지 않을 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("    (2) 혐오 분위기 조성자, 전염병자, 질병자, 만취자, 무단출입자 등 타인에게 공공의 피해가 있을 경우는 센터 출입을 통제할 수 있다.")]), _vm._v(" "), _c('li', [_vm._v("    (3) 강의실은 물 음료 제외 음식물 반입을 금지한다."), _c('br'), _vm._v("(단 행사의 목적 등을 고려하여 사전협의을 통해 승인이 된 경우 반입이 허용될 수 있다.)")]), _vm._v(" "), _c('li', [_vm._v("    (4) 규정 미준수 또는 심의에 부적절하다고 판정될 시 시설 이용을 할 수 없다.")]), _vm._v(" "), _c('li', [_vm._v("    (5) 정치활동, 영리활동 및 특정 종교활동 등의 행사에는 대관할 수 없다.")]), _vm._v(" "), _c('li', [_vm._v("    (6) 센터 내 보유 장비 및 시설의 외부 임대 사용 또는 대행(용역 포함)을 할 수 없다.")]), _vm._v(" "), _c('li', [_vm._v("    (7) 대관 신청 이용권의 임의 양도 및 전대는 할 수 없다.")]), _vm._v(" "), _c('li', [_vm._v("  2) 대관자의 의무")]), _vm._v(" "), _c('li', [_vm._v("    (1) 센터 공간과 물품을 항상 청결하게 사용하거나 유지해야 한다.")]), _vm._v(" "), _c('li', [_vm._v("    (2) 대관시간 종료 시까지 정리 정돈을 마치고 퇴실한다.")]), _vm._v(" "), _c('li', [_vm._v("    (3) 대관 목적 이외의 행사를 하여서는 아니 된다.")]), _vm._v(" "), _c('li', [_vm._v("    (4) 센터 내 영상음향장비 등 기자재 사용 시에는 담당 직원의 확인 및 지시에 따라야 한다.")]), _vm._v(" "), _c('li', [_vm._v("    (5) 대관 시 사용한 시설 및 장비 훼손 시 원상복구 및 손해배상의 의무가 있다."), _c('br'), _vm._v("(손해배상 시 이용자가 5일 이내에 동일한 물품 또는 그에 상당하는 현금으로 배상해야 한다.)")]), _vm._v(" "), _c('li', [_vm._v("    (6) 사용자는 대관한 장소 및 설비에 변경을 가하거나 특별한 장비를 반입하여 설치할 경우 사전 승인을 받아서 설치하며, 시설 사용을 완료하거나 중단하였을 때에는 바로 반입 설비를 철거, 원상복구한 후 센터 대관 담당자의 확인을 받아야 한다.")]), _vm._v(" "), _c('li', [_vm._v("    (7) 상기 사항 미준수 시는 시설 사용을 금지 또는 제한할 수 있으며 이로 인한 손해, 손실은 센터에서 책임지지 않는다.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("① 규칙에 의거하여 시설의 사용을 제한·취소할 경우, 사용자에게 손해가 있을지라도 캠퍼스는 그 배상책임을 지지 않습니다.")]), _vm._v(" "), _c('li', [_vm._v("② 시설 사용과 관련하여 발생한 사고에 대해서는 사용자가 민·형사상의 모든 책임을 집니다. 다만, 캠퍼스의 지시를 이행하였거나 캠퍼스와 사전 협의한 후 장치 및 시설물 등을 설치하여 사고가 발생한 경우에는 캠퍼스와 사용자가 책임한계를 협의하여 정합니다.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("① 사용자는 사용기간 중 시설 등에 대하여 선량한 관리자로서의 의무를 다하여야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("② 사용자가 관리의무를 태만히 하여 시설 등을 훼손하였을 때에는 훼손시설에 상당하는 손해배상을 하여야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("③ 사용자는 캠퍼스의 동의없이 그 권리를 양도하거나 전대할 수 없습니다.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("① 사용자가 시설 사용을 취소하고자 할 경우 마이페이지에서 사용 신청을 취소해야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("② 캠퍼스는 다음에 따라 사용료를 환불합니다.")]), _vm._v(" "), _c('li', [_vm._v("- 사용개시일 당일 : 환불불가")]), _vm._v(" "), _c('li', [_vm._v("- 사용개시일 전일까지 : 전액환불")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("① 규칙에 의거하여 대관시설의 사용을 제한·취소할 경우, 대관자에게 손해가 있을지라도 캠퍼스는 그 배상책임을 지지 않습니다.")]), _vm._v(" "), _c('li', [_vm._v("② 대관과 관련하여 발생한 사고에 대해서는 대관자가 민·형사상의 모든 책임을 집니다. 다만, 캠퍼스의 지시를 이행하였거나 캠퍼스와 사전 협의한 후 장치 및 시설물 등을 설치하여 사고가 발생한 경우에는 캠퍼스와 대관자가 책임한계를 협의하여 정합니다.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("① 대관자는 사용기간 중 시설 등에 대하여 선량한 관리자로서의 의무를 다하여야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("② 대관자가 관리의무를 태만히 하여 시설 등을 훼손하였을 때에는 훼손시설에 상당하는 손해배상을 하여야 합니다.")]), _vm._v(" "), _c('li', [_vm._v("③ 대관자는 캠퍼스의 동의없이 그 권리를 양도하거나 전대할 수 없습니다.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("① 대관자가 대관을 취소하고자 할 경우 대관취소신청서를 작성하여 캠퍼스에 제출하여야합니다.")]), _vm._v(" "), _c('li', [_vm._v("② 캠퍼스는 다음에 따라 사용료를 환불합니다.")]), _vm._v(" "), _c('li', [_vm._v("- 사용개시일 당일 : 환불불가")]), _vm._v(" "), _c('li', [_vm._v("- 사용개시일 전일까지 : 전액환불")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eed614c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/booking/BookingForm.vue
// module id = 1475
// module chunks = 6